import { Component, OnInit, Input, Inject, OnChanges, Output, EventEmitter } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { DialogUploadReceiptComponent, DialogUploadReceiptData } from '../dialog/dialog-upload-receipt.component';
import { DialogViewComponent, IDialogViewData } from '../dialog/dialog-view.component';
import { DialogConfirmDeleteComponent } from '../dialog/dialog-confirm-delete.component';

import { AppSheetHelpComponent } from '../../chrome/app-sheet-help.component';

import { base64StringToBlob, blobToBase64String } from 'blob-util';

import {
  AuthenticationService, ContactApiService,
  ApprovalTaskItemApiService, AnnotationApiService, BlobApiService
} from '../../data-services/index';

import {
  IApplication, IApprovalTask, IApprovalTaskItem,
  IApprovalTaskItemInput, IAnnotationInput, IHelp, IUser, IContact
} from '@ebb-v2/ebb-integration';

import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ebb-portal-receipt-list',
  templateUrl: './receipt-list.component.html'
})
export class ReceiptListComponent implements OnInit, OnChanges {
  @Input('title') title: string;
  @Input('application') application: IApplication;
  @Input('task') task: IApprovalTask;
  @Output() emitReceiptUploadEvent = new EventEmitter<IApprovalTask>();

  public currentUser: IUser;
  public currentContractor: IContact = null;

  public taskItems: IApprovalTaskItem[] = [];

  public waitForFilesToShow: number;
  public waitForFileToUpload = -1;
  public progressSaveIndicator = false;
  public showAddAnother = false;
  public showAddAnotheronreject = false;
  public fileUrl: any;
  public noteText?: string;
  public innerWidth;

  public deviceInfo: DeviceInfo;

  constructor(
    private readonly dialogUpload: MatDialog,
    private readonly deviceService: DeviceDetectorService,
    private readonly dialogView: MatDialog,
    private readonly dialogConfirmDelete: MatDialog,
    private readonly infoSheet: MatBottomSheet,
    private readonly authenticationService: AuthenticationService,
    private readonly apiApprovalTaskItem: ApprovalTaskItemApiService,
    private readonly apiAnnotation: AnnotationApiService,
    private readonly apiContact: ContactApiService,
    private readonly apiblob: BlobApiService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getContact();
    this.innerWidth = window.innerWidth;
    this.taskItems = this.buildFiles(this.task.approvalTaskItems);
    this.loadSubmittedFiles();
  }

  ngOnChanges() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getContact();
    this.taskItems = this.buildFiles(this.task.approvalTaskItems);
    this.loadSubmittedFiles();
  }

  private getContact(): void {
    this.apiContact.getContact(this.application._Ebb_ContractorId).subscribe(
      data => {
        this.currentContractor = data;
      },
      error => console.warn(`ERROR: UserAccount.getContact() - ${error}`)
    );
  }

  public loadSubmittedFiles(): void {
    this.waitForFilesToShow = 0;
    let itemsSubmitted = 0;
    this.taskItems.forEach(item => {
      if (item.statusCode > 700000000) {
        itemsSubmitted++;
        this.getSubmittedFile(item.payload);
      }
    });

    if (!this.showAddAnother) {
      itemsSubmitted >= 1 || (this.taskItems && this.taskItems.length === 0)
        ? (this.showAddAnother = true)
        : (this.showAddAnother = false);
    }

    if (
      this.application.eventApplicationSubmitted &&
      parseInt(this.application.submissionRejection?.toString(), 10) ===
        700000001
    ) {
      this.showAddAnotheronreject = true;
    }
    if (
      this.task.statusCode === 700000003 &&
      !this.application.eventApplicationSubmitted
    ) {
      this.showAddAnotheronreject = true;
    }
  }

  private getSubmittedFile(itemId: string): void {
    if (itemId && itemId.length > 0) {
      this.waitForFilesToShow++;
      this.apiAnnotation.getAnnotation(itemId).subscribe();
    }
  }

  private getapprovalTaskItem(itemId: string): void {
    if (itemId && itemId.length > 0) {
      this.waitForFilesToShow++;
      this.apiApprovalTaskItem.getItem(itemId).subscribe(
        data => {
          const indexItem = this.task.approvalTaskItems.findIndex(
            i => i.id === data.id
          );
          this.task.approvalTaskItems[indexItem] = data as IApprovalTaskItem;
          this.loadSubmittedFiles();
          //console.log(`Receipt: ${data.id}`);
        },
        error => {
          console.warn(error);
        }
      );
    }
  }

  // 1: Submitted Read-only; 2: Contractor Read-only; 3: ALL Edit
  public checkUploadAuthorization(item: IApprovalTaskItem): number {
    const retVal = 3;
    if (
      (this.application.stageCode === 700000000 &&
        this.application.eventPreliminaryReview === true) ||
      (this.application.stageCode === 700000001 &&
        this.application.eventApplicationSubmitted === true) ||
      this.application.stageCode >= 700000002
    ) {
      if (
        item.submissionReject > 0 &&
        (this.isHomeowner() ||
          (this.isContractor() &&
            this.application.contractorPermissionsCode === 700000001))
      ) {
        return 3;
      }
      return 1;
    }
    if (
      this.isContractor() &&
      this.application.contractorPermissionsCode === 700000003
    ) {
      return 2;
    }
    return retVal;
  }

  public onUploadFileEvent(
    payload: string,
    itemId: string,
    attachmentName: string = '',
    isNewItem: boolean,
    noteText?: string
  ): void {
    this.noteText = noteText;

    this.apiContact.getContact(this.application._Ebb_ContractorId).subscribe(
      data => {
        const dialogUploadDataItem: DialogUploadReceiptData = {} as DialogUploadReceiptData;
        dialogUploadDataItem.programType = this.application.programType;
        dialogUploadDataItem.attachmentName = attachmentName;
        dialogUploadDataItem.currentContractorType = this.application.contractorTypeCode;
        dialogUploadDataItem.currentContractorName = data.fullName;
        dialogUploadDataItem.currentContractorBusiness = data.businessName;      
        if (this.noteText && this.noteText.indexOf('REPLACED') !== 0) {
          const noteTextSplit = noteText.split(',');
          if (noteTextSplit.length > 1) {
            dialogUploadDataItem.receiptType = noteTextSplit[0];
            dialogUploadDataItem.receiptDate = new Date(
              noteTextSplit[1].substring(1)
            );
            dialogUploadDataItem.receiptVendor =
              noteTextSplit.length === 3
                ? noteTextSplit[2].substring(1)
                : noteTextSplit[2].substring(1) + ',' + noteTextSplit[3];
          }
        }

        const dialogRef = this.dialogUpload.open(DialogUploadReceiptComponent, {
          width: '350px',
          data: dialogUploadDataItem
        });

        dialogRef.afterClosed().subscribe(result => {
          let taskId: string;
          if (result && result.uploadFileName.length > 0) {
            this.progressSaveIndicator = true;
            this.waitForFileToUpload = 1;
            const fileName = result.uploadFileName.replace(/[;,/?:@&=+$]/g, '');
            blobToBase64String(result.uploadFile)
              .then(base64string => {
                const fileString64 = base64string;
                const receiptDate = new Date(result.receiptDate);
                const receiptDateString = `${receiptDate.getMonth() +
                  1}/${receiptDate.getDate()}/${receiptDate.getFullYear()}`;
                const approvalTaskItem: IApprovalTaskItemInput = {} as IApprovalTaskItemInput;

                if (isNewItem) {
                  approvalTaskItem.typeCode = 700000005;
                  approvalTaskItem.payloadTypeCode = 700000000;
                  approvalTaskItem.statusCode = 700000003;
                  approvalTaskItem.allowRecordCreation = true;
                  approvalTaskItem.payloadName = fileName;
                  taskId = this.task.id;
                } else {
                  const index = this.taskItems.findIndex(i => i.id === itemId);
                  approvalTaskItem.id = this.taskItems[index].id;
                  taskId = null;
                  approvalTaskItem.payloadName = fileName;
                }
                approvalTaskItem.name = result.receiptType;
                approvalTaskItem.itemNote = `${
                  result.receiptType
                }, ${receiptDateString}, ${result.receiptVendor}`;

                this.apiApprovalTaskItem
                  .saveItem(approvalTaskItem, this.application.id, taskId)
                  .subscribe(data => {
                    if (isNewItem) {
                      const newItem = data as IApprovalTaskItem;
                      this.task.approvalTaskItems.push(newItem);
                    }

                    const indexItem = this.task.approvalTaskItems.findIndex(
                      i => i.id === data.id
                    );
                    this.task.approvalTaskItems[
                      indexItem
                    ] = data as IApprovalTaskItem;
                    taskId = this.task.approvalTaskItems[indexItem].id;
                    const annotationInput: IAnnotationInput = {
                      id: payload,
                      _Objectid_Value: this.task.approvalTaskItems[indexItem]
                        .id,
                      objectTypeCode: 'cea_approvaltaskitem',
                      fileName: fileName,
                      fileSize: result.uploadFile.size,
                      mimeType: result.uploadFile.type,
                      subject: fileName,
                      noteText: `${result.receiptType}, ${receiptDateString}, ${
                        result.receiptVendor
                      }`,
                      documentBody: fileString64
                    };

                    this.apiAnnotation
                      .saveAnnotation(annotationInput)
                      .subscribe(
                        data => {
                          const newPayload = data.id;
                          this.getapprovalTaskItem(taskId);

                          if (this.task.statusCode !== 700000002) {
                            this.task.statusCode = 700000003;
                          }
                          this.task.approvalTaskItems[
                            indexItem
                          ].payload = newPayload;
                          this.task.approvalTaskItems[
                            indexItem
                          ].statusCode = 700000003;
                          this.task.approvalTaskItems[
                            indexItem
                          ].statusCodeOptionSet = 'Updated';
                          this.waitForFileToUpload = -1;
                          this.showAddAnother = true;
                          this.task.statusCode = this.setTaskStatus(
                            this.task,
                            this.task.approvalTaskItems
                          );
                          this.progressSaveIndicator = false;
                          this.emitReceiptUploadEvent.emit(this.task);
                          this.ngOnInit();
                        },
                        err =>
                          console.warn(
                            `ERROR: ReceiptListComponent.onUploadFileEvent, saveAnnotation - ${err}`
                          )
                      );
                  });
              })
              .catch(err => {
                console.warn(
                  `ERROR: ReceiptListComponent.onUploadFileEvent, Unable to convert receipt file`
                );
              });
          }
        });
      },
      error =>
        console.warn(
          `ERROR: ReceiptListComponent.onUploadFileEvent, UserAccount.getContact() - ${error}`
        )
    );
  }

  public onDeleteFileEvent(
    itemId: string,
    payload: string,
    payloadName: string
  ): void {
    const currentTaskItem: IApprovalTaskItem = this.taskItems.filter(
      i => i.id === itemId
    )[0];

    const dialogRef = this.dialogConfirmDelete.open(
      DialogConfirmDeleteComponent,
      {
        width: '400px',
        data: payloadName
      }
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.progressSaveIndicator = true;
        if (currentTaskItem.id && currentTaskItem.id.length > 0) {
          this.apiApprovalTaskItem.deleteItem(itemId,this.application.id).subscribe(
            data => {
              const index = this.task.approvalTaskItems.findIndex(
                i => i.id === data.id
              );
              this.task.approvalTaskItems.splice(index, 1);
              this.progressSaveIndicator = false;
              this.emitReceiptUploadEvent.emit(this.task);
              this.ngOnInit();
            },
            error =>
              console.warn(
                `ERROR: cannot delete approval task item file ${JSON.stringify(
                  error
                )}`
              )
          );
        } else {
          console.warn(`ERROR: Unable to delete file without ID`);
        }
      }
    });
  }

  public onViewFileEvent(payload: string): void {
    const taskItemView: IApprovalTaskItem = this.taskItems.filter(
      i => i.payload === payload
    )[0];
    const dialogViewDataItem: IDialogViewData = {} as IDialogViewData;
    //let dialogHeight, dialogWidth: string;

    if (!taskItemView.payload && taskItemView.payload.length === 0) {
      return;
    } else {
      if (this.onCheckToView(taskItemView.payloadName)) {
        //iOS does not allow open blob file in another tab
        if (this.deviceService.isMobile()) {
          dialogViewDataItem.annotationId = taskItemView.payload;
          dialogViewDataItem.viewType = 2;
          dialogViewDataItem.title = taskItemView.payloadName;
          const dialogRef = this.dialogView.open(DialogViewComponent, {
            maxWidth: '95vw',
            maxHeight: '85vh',
            height: '700px',
            width: '1000px',
            data: dialogViewDataItem
          });
        } else {
          this.openimage(taskItemView.payload, taskItemView.payloadName);
        }
      } else {
        this.saveAsSubmittedFile(taskItemView);
      }
    }
  }
  public openimage(payload: string, payloadName): void {
    const taskItemView: IApprovalTaskItem = this.taskItems.filter(
      i => i.payload === payload
    )[0];

    if (!taskItemView.payload && taskItemView.payload.length === 0) {
      return;
    }

    this.apiblob
      .getTaskFiles(payload, payloadName,1)
      .subscribe(
        fileBlob => {
          let navigator : any = window.navigator;
          if (navigator && navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(
              fileBlob,
              taskItemView.payloadName
            );
          } else {
            const linkToView = this.document.createElement('a');
            linkToView.href = window.URL.createObjectURL(fileBlob);
            linkToView.target = '_blank';
            linkToView.id = taskItemView.payloadName;
            document.body.appendChild(linkToView);
            linkToView.click();
            linkToView.remove();
          }
        },
        error => {
          console.warn(error);
        }
      );
  }

  private onCheckToView(payloadName: string): boolean {
    let retVal = false;
    if (payloadName && payloadName.length > 0) {
      const extension = payloadName.split('.').pop();
      switch (extension.toLowerCase()) {
        case 'jpg':
        case 'png':
          retVal = true;
          break;
        default:
          retVal = false;
      }
    }
    return retVal;
  }

  private saveAsSubmittedFile(taskItemView: IApprovalTaskItem): any {
    this.progressSaveIndicator = true;
    if (taskItemView.payload && taskItemView.payload.length > 0) {
     this.apiblob
       .getTaskFiles(
         taskItemView.payload,
         taskItemView.payloadName,1
       )
       .subscribe(
         fileBlob => {
           this.progressSaveIndicator = false;
           let navigator : any = window.navigator;
           if (navigator && navigator.msSaveOrOpenBlob) {
             navigator.msSaveOrOpenBlob(
               fileBlob,
               taskItemView.payloadName
             );
           } else {
             const downloadLink = this.document.createElement('a');
             downloadLink.href = window.URL.createObjectURL(fileBlob);
             downloadLink.download = taskItemView.payloadName;
             document.body.appendChild(downloadLink);
             downloadLink.click();
             downloadLink.remove();
           }
         },
         error => {
           console.warn(error);
         }
       );
    }
  }

  public lookupIndex(item: IApprovalTaskItem): number {
    return this.task.approvalTaskItems.findIndex(i => i.id === item.id);
  }

  public onClickShowReasonWhy(topic: string): void {
    const item: IHelp = {} as IHelp;
    item.question = 'Reason Why';
    item.answer = topic.replace(/(\r\n|\n|\r)/gm, '<br/>');
    this.infoSheet.open(AppSheetHelpComponent, { data: item });
  }

  public setTaskStatus(
    task: IApprovalTask,
    taskList: IApprovalTaskItem[]
  ): number {
    if (
      taskList.every(item => {
        return item.statusCode === 700000003;
      })
    ) {
      return 700000003;
    } else {
      return task.statusCode;
    }
  }

  private buildFiles(taskList: IApprovalTaskItem[]): IApprovalTaskItem[] {
    const ret: IApprovalTaskItem[] = [];

    taskList.forEach(item => {
      if (item.payload && item.payload.toString().indexOf(',') > 0) {
        const idList = item.payload.toString().split(',');
        const nameList = item.payloadName.toString().split(',');

        idList.forEach((id, index) => {
          const file = { ...item };
          file.payload = id;
          file.payloadName = nameList[index];
          if (item.annotations) {
            const annotation = item.annotations.find(
              x => x.id === item.payload.toString()
            );
            if (annotation) {
              file.ebbModifiedDate = annotation.modifiedOn;
            }
          }
          ret.push(file);
        });
      } else {
        if (
          taskList.length === 1 ||
          (taskList.length > 1 &&
            item.statusCode !== 70000000 &&
            item.name !== 'Upload retrofit receipt')
        ) {
          if (item.annotations) {
            const annotation = item.annotations.find(
              x => x.id === item.payload.toString()
            );
            if (annotation) {
              item.noteText = annotation.noteText;
            }
          }
          ret.push(item);
        }
      }
    });

    return ret;
  }

  /***     User Convenience Methods */
  public isHomeowner() : boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }
}
